import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '../../shared/services/utilities.service';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {

  // Set initial values
  login: {username?: string, password?: string} = {}; // two-way bound form vars
  submitted = false;
  loading: any;
  public showError: any = true;
  public error: any = `Invalid username or password. You'll need to try again.`;

  constructor(
    private _auth: AuthService,
    private router: Router,
    private _utilities: UtilitiesService
  ) { }

  ngOnInit() {
    // If the user is already logged in, redirect them to browse page.
    this._auth.isLoggedIn().subscribe(isLoggedIn => {
      if(!isLoggedIn) {
         this.router.navigate(['/login']);
      }
    });
  }

  onLogin(form) {
    this.submitted = true;

    // Is the form valid?
    if (form.valid) {

      this._auth.login(this.login.username, this.login.password).subscribe(
        data => {
          this._auth.handleJWT(data);
        },
        error => {
          this._auth.handleError();
          this.showError = true;
          this._utilities.createToasty({
            type: "error",
            msg: 'Your username or password are incorrect',
          });
      });
    }
  }


  /**
   *  Set the user in local storage and redirect to main clients dashboard
   */
  setUserAndRedirect(data) {
    let user = {
      auth_token: data.auth_token
    }

    // Store the user in local storage.
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('hewa-permission-level', 'manager');

    // Redirect to home screen.
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts